var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          items: _vm.items,
          busy: _vm.loading,
          fields: _vm.fields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          stacked: "md",
          "show-empty": "",
          small: "",
          "empty-text": "No Product Catalogues found.",
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-info my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Loading Catalogues...")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "empty",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "text-center py-4" },
                  [
                    _c("h5", { staticClass: "error-empty-catalogues" }, [
                      _vm._v(
                        "\n          " + _vm._s(scope.emptyText) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      { attrs: { to: "/catalogues/new", variant: "primary" } },
                      [_vm._v("\n          Create Product Catalogue\n        ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "cell(productsCount)",
            fn: function (row) {
              return [
                _c("span", [
                  _vm._v(
                    "\n        " + _vm._s(row.item.products.length) + "\n      "
                  ),
                ]),
              ]
            },
          },
          {
            key: "cell(active)",
            fn: function (row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("publishedStatus")(row.item.active)) +
                    "\n    "
                ),
              ]
            },
          },
          {
            key: "cell(actions)",
            fn: function (row) {
              return [
                _c(
                  "b-dropdown",
                  {
                    staticClass: "m-md-2",
                    attrs: { id: "dropdown-1", text: "Select", "no-caret": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _c(
                                "svg",
                                {
                                  staticClass: "bi bi-three-dots-vertical",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    viewBox: "0 0 16 16",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      { attrs: { to: `/catalogues/edit/${row.item.uuid}` } },
                      [_vm._v("\n          Edit Catalogue\n        ")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("b-pagination", {
        attrs: {
          "total-rows": _vm.items.length,
          "per-page": _vm.perPage,
          "first-text": "First",
          "prev-text": "Prev",
          "next-text": "Next",
          "last-text": "Last",
        },
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }